import { MessageBox } from 'element-ui'
import i18n from '../i18n'
import { get_upload_limit_info, token_check, get_dps_limit } from '@/services/user'
import { operateLog, getCookie, setCookie } from './tool'
import { getUrlQuery } from './router'
import CONFIG from '@/config'
import store from './../store'

/**
 * 全局使用token的地方，统一使用此方法获取
 * @returns token
 */
const invalidToken = [] // 无效token集合，防止urltoken失效仍旧请求token_check
export const getToken = () => {
  let token = getCookie('S2') || ''
  const urlQuery = getUrlQuery()
  if (urlQuery.token) {
    // url传入token，优先级最高
    token = urlQuery.token
    setCookie('S2', token, 30)
  }
  if ((token && token == undefined) || token === 'undefined') {
    token = ''
    setCookie('S2', '', -1)
  }
  if (invalidToken.includes(token)) {
    operateLog('invalidToken', invalidToken)
    return ''
  }
  return token
}
/**
 *
 * @param {String} title 标题
 * @param {Boolean} exceed 是否超限, 优先级最高，一般是接口返回
 * @param {number} num
 * @returns
 */
export const checkTrialPackageCardLimit = (title = '', exceed = false, num = 0, cb = null) => {
  /**
   * 试用套餐上传名片100张限制
   * 超管或者管理员上传名片时，额度超限，去购买
   * role:标准用户0、只读用户3，超限1，联系管理员2
   */
  return new Promise((resolve, reject) => {
    const { role = '' } = store.state.user.user_info
    // resolve()
    get_upload_limit_info({ token: getToken() })
      .then((res = {}) => {
        const {
          is_limit = '',
          limit_num = '',
          current_num = '',
          allowed_upload = ''
        } = res.data || {}
        /**
         * is_limit	是否限制 0：不限制 1：限制
         * limit_num	限制上传总量， 不限制时候为0
         * current_num	当前上传总量，不限制时候为0
         * allowed_upload	当前是否允许提交： 0：不允许 1：允许
         */

        const isExceed = exceed || !allowed_upload || current_num + num > limit_num
        if (res.errno === 0) {
          if (is_limit === 1 && isExceed) {
            const roleArr = [1, 2]
            const isAdmin = roleArr.includes(+role)
            MessageBox.confirm(
              isAdmin
                ? i18n.t('package_exceed_to_admin', [limit_num])
                : i18n.t('package_exceed_to_user', [limit_num]),
              title,
              {
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showConfirmButton: isAdmin,
                showCancelButton: isAdmin,
                confirmButtonText: i18n.t('buy_now'),
                cancelButtonText: i18n.t('cancel')
              }
            )
              .then(() => {
                location.href = '/payment/price'
                reject('upload_limit_info2')
              })
              .catch(() => {
                reject('upload_limit_info1')
              })
            typeof cb === 'function' && cb()
          } else {
            resolve()
          }
        } else {
          operateLog(`get_upload_limit_info fail ${title}`, res)
          reject('get_upload_limit_info fail')
        }
      })
      .catch(e => {
        console.log('get_upload_limit_info error', e)
        operateLog(`get_upload_limit_info error ${title}`, e)
        reject('get_upload_limit_info error')
      })
  })
}
/**
 * 清除用户信息
 */
export const clearUser = () => {
  // token已失效，将store中的数据删除
  store.commit('user/clearUserInfo')
  setCookie('S2', '', -1)
}
/**
 * token_check检查, 目前仅在全局路由守卫和登录页使用，其他页面后期再替换
 * @param {*} param0
 * @returns
 */
export const useTokenCheck = ({ detail, is_simpe, success, fail, catchFn }) => {
  const token = getToken()
  return token_check({
    token,
    detail,
    is_simpe,
    client_app: `web@${CONFIG.appVersion}`
  })
    .then(data => {
      if (data.exptime * 1000 > Date.now()) {
        if (detail === 3) {
          let account = getCookie('_cclog_account') || ''
          account = decodeURIComponent(account)
          store.commit('user/setUser', {
            token,
            is_corp_user: data.is_corp_user,
            type: data.type,
            user_info: {
              token,
              ...data,
              account
            }
          })
          if (window.fLog) {
            window.fLog.uidConfig(
              data.user_id || token,
              data.corp_id || token,
              data.corp_gid || token
            )
          }
        }
        success && success(data)
      } else {
        clearUser()
        operateLog('check_token', 'token过期')
        fail && fail()
        invalidToken.push(token)
      }
    })
    .catch(e => {
      invalidToken.push(token)
      operateLog('check_token', 'token_check catch')
      catchFn && catchFn(e)
    })
}
/**
 * 判断是否登录
 * @returns boolean
 */
export const useLoginStatus = () => {
  return getToken().length > 0
}

/**
 * 提醒DPS额度不足弹窗
 * @param {*} from 0 默认值[名片夹/管理页]， 1 登录页调用， 2点击上传名片图按钮调用
 * @returns
 */
export const checkDpsPopupStatus = () => {
  return new Promise(resolve => {
    const { show, lastTime } = store.state.user.dpsLimit
    const now = Date.now()
    const gap = 4 * 60 * 60 * 1000 // 线上环境，4小时间隔
    let lastTimeNew = 0
    if (show) {
      // 目前弹窗处于显示状态，不用再检查
      resolve()
      return
    }
    // 日本人反馈提示太频繁，现在统一4小时提醒一次
    // 四小时调用一次接口
    if (!lastTime || now - lastTime > gap) {
      // 未检查过，立即调用
      // 检查过，但是超过四小时，重新检查
      lastTimeNew = now
    } else {
      lastTimeNew = lastTime
      resolve()
      return
      // 检查过，但是不超过四小时，不再检查
    }
    // dps_quota_reminder: 0: 不通知 1: 额度不足  2: 没有额度了
    get_dps_limit()
      .then(res => {
        let type = 0
        if (+res?.errno === 0) {
          type = res.data.dps_quota_reminder
        }
        const { email = [], phone = [] } = res.data.super_admin_contact
        const contact = [...email, ...phone]
        store.commit('user/setDpsLimit', {
          type,
          show: !!type,
          lastTime: lastTimeNew,
          contact: contact.join(';')
        })
        resolve()
      })
      .catch(() => {
        resolve()
      })
  })
}

export const updateDpsPopupStatus = () => {
  store.commit('user/setDpsLimit', {
    show: false
  })
}
